module.exports = __webpack_public_path__ + "static/media/tableroDigitalIcon.32791ff5.jpg";